export default {"src":"/_next/static/media/HeroImage.f1b085ba.svg","height":282,"width":520,"blurWidth":0,"blurHeight":0};